export default "__VITE_ASSET__BrZxsFaz__"